<template>
    <div>
        <template
            v-for="(task, index) in tasks"
        >
            <div class="row">
                <div
                    :key="`task-${task.id}`"
                    v-if="currentTask === index"
                    class="col-12 row"
                >
                    <div class="col">
                        <component
                            :is="task.component_name"
                            v-model="form"
                            :current-task="currentTask"
                            :task="task"
                        />
                    </div>
                </div>
            </div>
        </template>
        <div
            v-if="tasks.length > currentTask"
            class="row mt-4 d-block"
        >
            <div
                class="col-12 text-right d-inline-flex align-items-center"
                :class="{'justify-content-end': duration === null, 'justify-content-between': duration !== null}"
            >
                <div
                    v-if="duration !== null"
                    class="text-left"
                >
                    <div class="btn btn-primary d-inline-flex align-items-center text-nowrap" style="width: 150px; cursor: auto">
                        <svg xmlns="http://www.w3.org/2000/svg" class="mr-2" style="width: 30px" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        {{ leftTime.minutes }} : {{ leftTime.seconds }}
                    </div>
                </div>
                <div class="d-inline-flex align-items-center justify-content-end">
                    <div class="mr-4">
                        {{ currentTask + 1 }} / {{ tasks.length }}
                    </div>
                    <button
                        type="button"
                        class="btn btn-primary"
                        @click.prevent="saveTask"
                    >
                        Következő feladat
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import { filter, map, first, findIndex } from "lodash";
import TaskAnswerSelector from "./Task/TaskAnswerSelector";
import moment from 'moment';
export default {
    components: {
        TaskAnswerSelector,
    },
    data() {
        return {
            isLoading: false,
            tasks: [],
            currentTask: 0,
            form: {},
            gameTimer: null,
            timer: 0,
            duration: window.InteractiveInterfaceDuration || null,
            endGameTimer: null,
        }
    },
    watch: {
        timer(value) {
            window.localStorage.setItem('gameTime', value);
        },
        currentTask() {
            this.makeDuration();
            this.setTimer();
        }
    },
    created() {
        if (window.localStorage.getItem('gameTime') && this.timer) {
            this.timer = parseInt(window.localStorage.getItem('gameTime'));
        }

        this.fetchTasks();
        this.setTimer();
        this.checkEndGame();
    },
    computed: {
        leftTime() {
            const calculatedTimer = this.duration - this.timer;
            const minutes = Math.floor(calculatedTimer / 60);
            return {
                minutes: String(minutes).padStart(2, '0'),
                seconds: String(Math.round(calculatedTimer - (minutes * 60))).padStart(2, '0'),
            };
        }
    },
    methods: {
        checkEndGame() {
            clearInterval(this.endGameTimer);


            if (! this.$root.interactiveInterface.fill_end_at) {
                return;
            }

            this.endGameTimer = setInterval(() => {
                if (this.$root.interactiveInterface.fill_end_at <= moment().format('YYYY-MM-DD HH:MM')) {
                    this.saveTaskAsClose();
                    clearInterval(this.endGameTimer);
                    return;
                }
            }, 1000);
        },
        setTimer() {
            clearInterval(this.gameTimer);

            if (this.duration === null) {
                return;
            }

            this.gameTimer = setInterval(() => {
                this.timer++;

                if (this.duration && (this.duration - this.timer) <= 0) {
                    this.timer = 0;

                    clearInterval(this.gameTimer);

                    if (window.InteractiveInterfaceDuration !== '') {
                        this.$emit('close');
                        return;
                    }

                    this.saveTask();
                }
            }, 1000);
        },
        makeDuration() {
            if (window.InteractiveInterfaceDuration !== '') {
                this.duration = window.InteractiveInterfaceDuration;
                return;
            }

            if (this.tasks[this.currentTask] && this.tasks[this.currentTask].duration) {
                this.duration = this.tasks[this.currentTask].duration;
                return;
            }

            this.duration = null;

        },
        hasInteractiveInterfaceDuration() {
            return this.duration !== null;
        },
        fetchTasks() {
            axios.get(`${this.$root.getUrlPrefix()}/${this.$root.user.fingerprint}/tasks`).then((response) => {
                this.tasks = response.data.tasks;

                const nextTask = first(filter(this.tasks, (task) => {
                    return !map(this.$root.user.game_tasks, 'task_id').includes(task.id);
                }));

                this.currentTask = findIndex(this.tasks, nextTask) || 0;

                this.makeDuration();
                this.setTimer();
            });
        },
        saveTaskAsClose() {
            axios.post(`${this.$root.getUrlPrefix()}/${this.$root.user.fingerprint}/tasks`, {
                form: this.form,
            }).then((response) => {
                this.form = {};
                this.$root.user = response.data.user;

                this.$emit('close');
            });
        },
        saveTask() {
            axios.post(`${this.$root.getUrlPrefix()}/${this.$root.user.fingerprint}/tasks`, {
                form: this.form,
            }).then((response) => {
                this.form = {};
                this.$root.user = response.data.user;

                let nextTask = this.currentTask++;

                if (this.tasks[nextTask] === undefined) {
                    this.$emit('next');
                    return;
                }

                this.currentTask = this.currentTask++;

                if (!(!!window.InteractiveInterfaceDuration) && this.duration) {
                    this.timer = 0;
                    clearInterval(this.gameTimer);
                }
            });
        },
    }
}
</script>
